import { render, staticRenderFns } from "./StepTreatmentSelector.vue?vue&type=template&id=201e635c&"
import script from "./StepTreatmentSelector.vue?vue&type=script&lang=js&"
export * from "./StepTreatmentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports